import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  card: {
    margin: theme.spacing.unit * 4,
    minWidth: 275,
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
})


function SimpleCard(props) {
  const { classes } = props;

  return (
    <Fragment>
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            IEEE International Conference on Data Engineering (ICDE), 2020
          </Typography>
          <Typography variant="h5" component="h2">
            ForkBase: Immutable, Tamper-evident Storage Substrate for Branchable Applications
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            Demonstration Paper
          </Typography>
          <Typography variant="body2" component="p">
            Qian Lin, Kaiyuan Yang, Tien Tuan Anh Dinh, Qingchao Cai, Gang Chen, Beng Chin Ooi,Pingcheng Ruan, Sheng Wang, Zhongle Xie, Meihui Zhang, Olafs Vandans.
          </Typography>
        </CardContent>
        <CardActions>
          <a href="https://www.comp.nus.edu.sg/~dbsystem/download/ICDE2020-ForkBaseDemo-CameraReady.pdf" target="_blank" rel="noopener noreferrer">
            <Button size="small">Paper Link</Button>
          </a>
        </CardActions>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            Int'l Conference on Very Large Data Bases (VLDB), 2018.
          </Typography>
          <Typography variant="h5" component="h2">
            ForkBase: An Efficient Storage Engine for Blockchain and Forkable Applications
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            Research Paper
          </Typography>
          <Typography variant="body2" component="p">
            Sheng Wang, Tien Tuan Anh Dinh, Qian Lin, Zhongle Xie, Meihui Zhang, Qingchao Cai, Gang Chen, Beng Chin Ooi, Pingcheng Ruan.
          </Typography>
        </CardContent>
        <CardActions>
          <a href="http://www.vldb.org/pvldb/vol11/p1137-wang.pdf" target="_blank" rel="noopener noreferrer">
            <Button size="small">Paper Link</Button>
          </a>
        </CardActions>
      </Card>
    </Fragment>
  );
}

export default withStyles(styles)(SimpleCard);
